/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReservedBloodProductsViewerAliases {
  CONTEXTUAL_BAR_ACTION_REVERSE = 'contextual-bar-action-reverse',
  CONTEXTUAL_BAR_ACTION_SUSPEND = 'contextual-bar-action-suspend',
  CONTEXTUAL_BAR_ACTION_TERMINATE = 'contextual-bar-action-terminate',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INTERRUPT_BUTTON = 'interrupt-button',
  PANEL_HEADER = 'panel-header',
  RESERVED_BLOOD_PRODUCTS_VIEWER_CARD = 'reserved-blood-products-viewer-card',
  RESERVED_BLOOD_PRODUCTS_VIEWER_CONTENT_PANEL = 'reserved-blood-products-viewer-content-panel',
  RESERVED_BLOOD_PRODUCTS_VIEWER_CONTEXTUAL_BAR = 'reserved-blood-products-viewer-contextual-bar',
  RESERVED_BLOOD_PRODUCTS_VIEWER_DECK = 'reserved-blood-products-viewer-deck',
  RESERVED_BLOOD_PRODUCTS_VIEWER_FOOTER_PANEL = 'reserved-blood-products-viewer-footer-panel',
  RESERVED_BLOOD_PRODUCTS_VIEWER_LAYOUT = 'reserved-blood-products-viewer-layout',
  START_BUTTON = 'start-button',
}
export { ReservedBloodProductsViewerAliases };
